import React from "react";
import { Routes, Route } from "react-router-dom";
import Router from "./config/Router";
import "./index.css";

function App() {
  return <Router />;
}
export default App;